import { Injectable } from '@angular/core';
import { HttpClient, HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PowerBIService {
  powerBI$: BehaviorSubject<any>;

  constructor(private http: HttpClient) { 
    this.powerBI$ = new BehaviorSubject(null);
  }

  getPowBIData(dataSetID, data, token){
    return new Promise((resolve) => {
    this.http.post("https://api.powerbi.com/v1.0/myorg/datasets/"+dataSetID+"/executeQueries", data, {headers:{Authorization:'Bearer '+token}})
    .subscribe(
      (response: any) => {

          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          resolve(response)
          console.log(response)
        
      }, (error: any) => {
        resolve(error)
      }
    );
    })
    

  }

  getPowBIGroups(token){
    return new Promise((resolve) => {
    this.http.get("https://api.powerbi.com/v1.0/myorg/groups", {headers:{Authorization:'Bearer '+token}})
    .subscribe(
      (response: any) => {

          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          resolve(response)
          console.log(response)
        
      }, (error: any) => {
        resolve(error)
      }
    );
    })
    

  }

  getDatasetsByGroupid(id, token){
    return new Promise((resolve) => {
    this.http.get("https://api.powerbi.com/v1.0/myorg/groups/"+id+"/datasets", {headers:{Authorization:'Bearer '+token}})
    .subscribe(
      (response: any) => {

          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          resolve(response)     
      }, (error: any) => {
        resolve(error)
      }
    );
    })
    

  }
}
